/* eslint-disable func-names */
import { takeLatest, takeEvery, put, call } from "redux-saga/effects";
import "whatwg-fetch";
import * as GlobalActions from "../../actions";
import * as Actions from "./store/actions";
import ActionTypes from "../../constants";
import * as Apis from "./apis";
import { wrapByLoader, wrapWithoutLoader } from "../../utils";

const fetchLookUp = () =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.fetchLookUpApi);
      if (!response.error) {
        const lookup = response.data;
        yield put(Actions.fetchLookUpSucceeded(lookup));
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const retainUpdatedBusinessParter = ({
  businessPartnerID
}: Actions.RetainUpdatedBusinessPartnerActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(
        Apis.retainUpdatedBusinessParterApi,
        businessPartnerID
      );
      if (!response.error) {
        const retainedData = response.data[0];
        yield put(Actions.retainUpdatedBusinessParterSucceeded(retainedData));
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const fetchCitiesAndPostalCodesByCountry = ({
  countryID
}: Actions.fetchCitiesAndPostalCodesByCountryActtionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(
        Apis.fetchCitiesAndPostalCodesByCountryApi,
        countryID
      );

      if (!response.error) {
        const cities = response.data.cities;
        const postalCodes = response.data.postalcodes;
        const stateProvinces = response.data.stateProvince;
        yield put(
          Actions.fetchCitiesAndPostalCodesByCountrySucceeded(
            cities,
            postalCodes,
            stateProvinces
          )
        );
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const checkDubplicateOf = ({ payload }: Actions.CheckDubplicateOfActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.checkDubplicateOfApi, payload);
      if (!response.error) {
        const duplicateBPs = response.data.businessPartner || [];
        const paginationInfo = response.data.pageInfo;
        yield put(
          Actions.checkDubplicateOfSucceeded(duplicateBPs, paginationInfo)
        );
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const deleteDuplicateBP = ({
  businessPartnerID
}: Actions.DeleteDuplicateBPActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.deleteDuplicateBPApi, businessPartnerID);
      if (!response.error) {
        yield put(Actions.deleteDuplicateBPSucceeded(businessPartnerID));
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const createCity = ({ payload, cityOf }: Actions.CreateCityActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.createCityApi, payload);
      if (!response.error) {
        const city = response.data.body.city;
        if (cityOf === "address") {
          yield put(Actions.createCitySucceeded(city));
        } else if (cityOf === "pobox") {
          yield put(Actions.createPoBoxCitySucceeded(city));
        }
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });
const updateCity = ({ cityID, payload, cityOf }: Actions.UpdateCityActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.updateCityApi, { cityID, payload });
      if (!response.error) {
        const city = response.data.body.city;
        if (cityOf === "address") {

          yield put(Actions.updateCitySucceeded(city));
        } else if (cityOf === "pobox") {
          yield put(Actions.updatePoBoxCitySucceeded(city));

        }
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const createPostalCode = ({ payload, zipCodeOf }: Actions.CreatePostalCodeActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.createPostalCodeApi, payload);
      if (!response.error) {
        const postalCode = response.data.body.postalcode;
        if (zipCodeOf === "address") {

          yield put(Actions.createPostalCodeSucceeded(postalCode));
        } else if (zipCodeOf === "pobox") {
          yield put(Actions.createPoBoxPostalCodeSucceeded(postalCode));

        }
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const updatePostalCode = ({
  postalCodeID,
  payload,
  zipCodeOf
}: Actions.UpdatePostalCodeActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.updatePostalCodeApi, {
        postalCodeID,
        payload
      });
      if (!response.error) {
        const postalCode = response.data.body.postalcode;
        if (zipCodeOf === "address") {
          yield put(Actions.updatePostalCodeSucceeded(postalCode));
        } else if (zipCodeOf === "pobox") {
          yield put(Actions.updatePoBoxPostalCodeSucceeded(postalCode));
        }
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const createBusinessPartner = ({
  payload
}: Actions.CreateBusinessPartnerActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.createBusinessPartnerApi, payload);
      if (!response.error) {
        yield put(Actions.createBusinessPartnerSucceeded());
      } else {
        if (response.error.status === 409) {
          response.error.errorType = "custom";
          response.error.statusMessage = response.error.message;
          yield put(GlobalActions.errorOccured(response));
        } else {
          yield put(GlobalActions.errorOccured(response));
        }
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const updateBusinessPartner = ({
  payload
}: Actions.UpdateBusinessPartnerActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(Apis.updateBusinessPartnerApi, payload);
      if (!response.error) {
        yield put(Actions.updateBusinessPartnerSucceeded(payload.bpStatus));
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

const deleteBusinessPartner = ({
  businessPartnerID
}: Actions.DeleteBusinessPartnerActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(
        Apis.deleteBusinessPartnerApi,
        businessPartnerID
      );
      if (!response.error) {
        yield put(Actions.deleteBusinessPartnerSucceeded());
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });



const fetchBicSwifts = ({
  bankCountryCode
}: Actions.FetchBicSwiftsActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(
        Apis.fetchBicSwiftsApi,
        bankCountryCode
      );

      if (!response.error) {
        const bicSwifts = response.data.bankBranchDetails || [];
        yield put(
          Actions.fetchBicSwiftsSucceeded(
            bicSwifts,
          )
        );
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });


const fetchBankBranch = ({
  bicSwiftCode
}: Actions.fetchBankBranchActionType) =>
  wrapByLoader(function* () {
    try {
      const response = yield call(
        Apis.fetchBankBranchApi,
        bicSwiftCode
      );

      if (!response.error) {
        const bankBranch = response.data || {};

        yield put(
          Actions.fetchBankBranchSucceeded(
            bankBranch,
          )
        );
      } else {
        yield put(GlobalActions.errorOccured(response));
      }
    } catch (err) {
      yield put(GlobalActions.networkErrorOccured(err));
    }
  });

export default [
  takeLatest(ActionTypes.FETCH_LOOKUP, fetchLookUp),
  takeLatest(
    ActionTypes.FETCH_CITIES_AND_POSTAL_CODES_BY_COUNTRY,
    fetchCitiesAndPostalCodesByCountry
  ),
  takeEvery(ActionTypes.CHECK_DUBPLICATE_OF, checkDubplicateOf),
  takeLatest(ActionTypes.DELETE_DUPLICATE_BP, deleteDuplicateBP),
  takeLatest(ActionTypes.CREATE_CITY, createCity),
  takeLatest(ActionTypes.UPDATE_POSTAL_CODE, updatePostalCode),
  takeLatest(ActionTypes.UPDATE_CITY, updateCity),
  takeLatest(ActionTypes.CREATE_BUSINESS_PARTNER, createBusinessPartner),
  takeLatest(ActionTypes.CREATE_POSTAL_CODE, createPostalCode),
  takeLatest(ActionTypes.UPDATE_BUSINESS_PARTNER, updateBusinessPartner),
  takeLatest(
    ActionTypes.RETAIN_UPDATED_BUSINESS_PARTNER,
    retainUpdatedBusinessParter
  ),
  takeLatest(ActionTypes.DELETE_BUSINESS_PARTNER, deleteBusinessPartner),
  takeLatest(ActionTypes.FETCH_BIC_SWIFTS, fetchBicSwifts),
  takeLatest(ActionTypes.FETCH_BANK_BRANCH, fetchBankBranch)
];
